import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({
  isAuthenticated,
  component: Component,
  user,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        isAuthenticated ? <Redirect to={user?.redirect_url ?? user.role?.redirect_url ?? '/'} /> : <Component {...props} />
      }
    />
  );
};

const mapStateToProps = (state) => ({
  user: state.app.user,
  isAuthenticated: !!state.app.user,
});

export default connect(mapStateToProps)(PublicRoute);
